define("shared/components/shared/mavely/links/select-modal", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "shared/utils/uuid", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _utils, _component2, _tracking, _emberConcurrency, _uuid, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"shared/utils/uuid",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal @backdrop={{true}} @close={{@close}} @primaryClass="o--modalBg" as |modal|>
    <modal.card
      class="cLB--linksModal cLB--linksModalCard {{if (or this.isLoading (not this.hasLinks)) 'is--dark'}}"
      data-qa-id="qa--mib_mavely_links_search_modal"
    >
      <modal.card-header class="o--modalHeader cLB--linksModal__header u--flex__col u--p__lr__0 u--p__b__0">
        <div class="u--flex u--flex__alignItems--center u--p__lr__lg u--m__b__md">
          <p class="o--modalHeader__title u--p__r__xs" data-qa-id="qa--mavely_links_search_modal_title_txt">
            {{t "mavely.links_modal.title"}}
          </p>
          {{! @glint-expect-error: Shared::Badge }}
          <Shared::Badge
            @className="cVL--badge is--poweredBy is--mavely u--p__r__xs u--text--xs"
            @poweredByIcon="mavely-logo-text"
          />
        </div>
        <hr class="u--m__0" />
        {{#if (and (user-agent "device.isMobile") this.hasFolders)}}
          <Shared::Mavely::Links::MobileTabs
            @isFoldersTabActive={{this.isFoldersTabActive}}
            @setActiveFoldersTab={{set this "isFoldersTabActive"}}
          />
        {{/if}}
  
        {{#if this.hasSelectedFolderOnMobile}}
          <div class="u--text--light u--p__tb u--p__lr__lg">
            <Shared::Ui::Button
              @class="u--flex u--flex__alignItems--center"
              @onClick={{fn this.selectFolder undefined}}
              @variant="unstyled"
            >
              {{svg-jar "nav-left" class="o--icon--xs"}}
              <span class="u--m__lr__sm">{{t "shared_phrases.back"}}</span>
            </Shared::Ui::Button>
          </div>
          {{#if this.selectedFolderId}}
            <hr class="u--m__0" />
            <div class="u--text--bold u--text--md u--p__tb u--p__lr__lg">
              {{#let (find-by "id" this.selectedFolderId this.folders) as |selectedFolder|}}
                {{selectedFolder.name}}
                ({{selectedFolder.affiliate_links.length}})
              {{/let}}
            </div>
          {{/if}}
          <hr class="u--m__0" />
        {{else if (not this.isFoldersTabActive)}}
          <Shared::Mavely::Links::Search
            @clearSearch={{this.clearSearch}}
            @mavelyProfile={{@mavelyProfile}}
            @numberOfLinks={{this.links.length}}
            @searchQuery={{this.searchQuery}}
            @setSearchResults={{this.setLinksData}}
          />
          <hr class="u--m__0" />
        {{/if}}
      </modal.card-header>
      {{#if this.isLoading}}
        <Shared::LoadingSpinner />
      {{else}}
        <modal.card-body class="o--maxHeight cLB--linksModalBody">
          {{#if this.hasFoldersInSidebar}}
            <Shared::Mavely::Links::FoldersTab
              @canLoadMore={{this.hasMoreFolders}}
              @folders={{this.folders}}
              @loadMore={{this.fetchMoreFolders}}
              @selectFolder={{this.selectFolder}}
              @selectedFolderId={{this.selectedFolderId}}
              @totalLinks={{this.linksCount}}
            />
          {{/if}}
          {{#if this.isFetchingLinks}}
            <div class={{if this.hasFoldersInSidebar "u--col__9" "u--col__12"}}>
              <Shared::LoadingSpinner />
            </div>
          {{else if this.isSelectingFoldersOnMobile}}
            <Shared::Mavely::Links::FoldersTab
              @canLoadMore={{this.hasMoreFolders}}
              @folders={{this.folders}}
              @loadMore={{this.fetchMoreFolders}}
              @selectFolder={{this.selectFolder}}
              @selectedFolderId={{this.selectedFolderId}}
              @totalLinks={{this.linksCount}}
            />
          {{else if this.hasLinks}}
            <div
              class={{concat-classes
                "u--p__0 o--maxHeight"
                (if this.hasFoldersInSidebar "u--col__9" "u--col__12")
                (if this.hasMoreLinks "u--p__b__xs")
              }}
              data-qa-id="qa--mavely_links_scrollable_area"
              data-test-id={{if
                this.selectedFolderId
                (concat "selected-folder-" this.selectedFolderId "-links")
                "all-links"
              }}
              {{did-insert this.bindScrollEvent}}
              {{perfect-scroll this.scrollbarId updateTrigger=(and this.links.length this.folders.length)}}
            >
              <div class="cLB--linksModal__header cLB--linksModal__bodyHeader cLB--linkItem u--text--xs u--text--bold">
                <div class="cLB--linkItem__productWrapper">
                  {{t "mavely.links_modal.body_header.product"}}
                </div>
                <div class="cLB--linkItem__dateWrapper">
                  {{t "mavely.links_modal.body_header.date_added"}}
                </div>
              </div>
              {{#each this.links as |link|}}
                <Shared::Mavely::Links::Link @link={{link}} @selectLink={{@selectLink}} />
                <hr class="u--m__0" />
              {{/each}}
  
              {{#if this.canLoadMoreLinks}}
                <div class="u--m">
                  <Shared::Ui::Button
                    @additional="block"
                    @class="cLB--linksModal__footer u--text--hl"
                    @promise={{this.fetchMoreLinks}}
                    @text={{t "shared_phrases.load_more"}}
                    @variant="outline"
                    data-qa-id="qa--mavely_links_load_more_btn"
                    data-test-id="load-more-links-button"
                  />
                </div>
              {{/if}}
            </div>
          {{else if this.searchQuery}}
            <div
              class={{concat-classes
                "u--flex u--flex__justify--center u--flex__alignSelf--center"
                (if this.hasFoldersInSidebar "u--col__9" "u--col__12")
              }}
            >
              <p class="u--text--hair u--text--light" data-test-id="no-search-results">
                {{t "mavely.links_modal.search.no_results" searchQuery=this.searchQuery}}
              </p>
            </div>
          {{/if}}
        </modal.card-body>
      {{/if}}
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "55pQ3uDW",
    "block": "[[[8,[39,0],null,[[\"@backdrop\",\"@close\",\"@primaryClass\"],[true,[30,1],\"o--modalBg\"]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,2,[\"card\"]],[[16,0,[29,[\"cLB--linksModal cLB--linksModalCard \",[52,[28,[37,2],[[30,0,[\"isLoading\"]],[28,[37,3],[[30,0,[\"hasLinks\"]]],null]],null],\"is--dark\"]]]],[24,\"data-qa-id\",\"qa--mib_mavely_links_search_modal\"]],null,[[\"default\"],[[[[1,\"\\n    \"],[8,[30,2,[\"card-header\"]],[[24,0,\"o--modalHeader cLB--linksModal__header u--flex__col u--p__lr__0 u--p__b__0\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"u--flex u--flex__alignItems--center u--p__lr__lg u--m__b__md\"],[12],[1,\"\\n        \"],[10,2],[14,0,\"o--modalHeader__title u--p__r__xs\"],[14,\"data-qa-id\",\"qa--mavely_links_search_modal_title_txt\"],[12],[1,\"\\n          \"],[1,[28,[35,4],[\"mavely.links_modal.title\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"],[1,\"        \"],[8,[39,5],null,[[\"@className\",\"@poweredByIcon\"],[\"cVL--badge is--poweredBy is--mavely u--p__r__xs u--text--xs\",\"mavely-logo-text\"]],null],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,\"hr\"],[14,0,\"u--m__0\"],[12],[13],[1,\"\\n\"],[41,[28,[37,6],[[28,[37,7],[\"device.isMobile\"],null],[30,0,[\"hasFolders\"]]],null],[[[1,\"        \"],[8,[39,8],null,[[\"@isFoldersTabActive\",\"@setActiveFoldersTab\"],[[30,0,[\"isFoldersTabActive\"]],[28,[37,9],[[30,0],\"isFoldersTabActive\"],null]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"hasSelectedFolderOnMobile\"]],[[[1,\"        \"],[10,0],[14,0,\"u--text--light u--p__tb u--p__lr__lg\"],[12],[1,\"\\n          \"],[8,[39,10],null,[[\"@class\",\"@onClick\",\"@variant\"],[\"u--flex u--flex__alignItems--center\",[28,[37,11],[[30,0,[\"selectFolder\"]],[27]],null],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n            \"],[1,[28,[35,12],[\"nav-left\"],[[\"class\"],[\"o--icon--xs\"]]]],[1,\"\\n            \"],[10,1],[14,0,\"u--m__lr__sm\"],[12],[1,[28,[35,4],[\"shared_phrases.back\"],null]],[13],[1,\"\\n          \"]],[]]]]],[1,\"\\n        \"],[13],[1,\"\\n\"],[41,[30,0,[\"selectedFolderId\"]],[[[1,\"          \"],[10,\"hr\"],[14,0,\"u--m__0\"],[12],[13],[1,\"\\n          \"],[10,0],[14,0,\"u--text--bold u--text--md u--p__tb u--p__lr__lg\"],[12],[1,\"\\n\"],[44,[[28,[37,14],[\"id\",[30,0,[\"selectedFolderId\"]],[30,0,[\"folders\"]]],null]],[[[1,\"              \"],[1,[30,3,[\"name\"]]],[1,\"\\n              (\"],[1,[30,3,[\"affiliate_links\",\"length\"]]],[1,\")\\n\"]],[3]]],[1,\"          \"],[13],[1,\"\\n\"]],[]],null],[1,\"        \"],[10,\"hr\"],[14,0,\"u--m__0\"],[12],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,3],[[30,0,[\"isFoldersTabActive\"]]],null],[[[1,\"        \"],[8,[39,15],null,[[\"@clearSearch\",\"@mavelyProfile\",\"@numberOfLinks\",\"@searchQuery\",\"@setSearchResults\"],[[30,0,[\"clearSearch\"]],[30,4],[30,0,[\"links\",\"length\"]],[30,0,[\"searchQuery\"]],[30,0,[\"setLinksData\"]]]],null],[1,\"\\n        \"],[10,\"hr\"],[14,0,\"u--m__0\"],[12],[13],[1,\"\\n      \"]],[]],null]],[]]],[1,\"    \"]],[]]]]],[1,\"\\n\"],[41,[30,0,[\"isLoading\"]],[[[1,\"      \"],[8,[39,16],null,null,null],[1,\"\\n\"]],[]],[[[1,\"      \"],[8,[30,2,[\"card-body\"]],[[24,0,\"o--maxHeight cLB--linksModalBody\"]],null,[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"hasFoldersInSidebar\"]],[[[1,\"          \"],[8,[39,17],null,[[\"@canLoadMore\",\"@folders\",\"@loadMore\",\"@selectFolder\",\"@selectedFolderId\",\"@totalLinks\"],[[30,0,[\"hasMoreFolders\"]],[30,0,[\"folders\"]],[30,0,[\"fetchMoreFolders\"]],[30,0,[\"selectFolder\"]],[30,0,[\"selectedFolderId\"]],[30,0,[\"linksCount\"]]]],null],[1,\"\\n\"]],[]],null],[41,[30,0,[\"isFetchingLinks\"]],[[[1,\"          \"],[10,0],[15,0,[52,[30,0,[\"hasFoldersInSidebar\"]],\"u--col__9\",\"u--col__12\"]],[12],[1,\"\\n            \"],[8,[39,16],null,null,null],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"isSelectingFoldersOnMobile\"]],[[[1,\"          \"],[8,[39,17],null,[[\"@canLoadMore\",\"@folders\",\"@loadMore\",\"@selectFolder\",\"@selectedFolderId\",\"@totalLinks\"],[[30,0,[\"hasMoreFolders\"]],[30,0,[\"folders\"]],[30,0,[\"fetchMoreFolders\"]],[30,0,[\"selectFolder\"]],[30,0,[\"selectedFolderId\"]],[30,0,[\"linksCount\"]]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"hasLinks\"]],[[[1,\"          \"],[11,0],[16,0,[28,[37,18],[\"u--p__0 o--maxHeight\",[52,[30,0,[\"hasFoldersInSidebar\"]],\"u--col__9\",\"u--col__12\"],[52,[30,0,[\"hasMoreLinks\"]],\"u--p__b__xs\"]],null]],[24,\"data-qa-id\",\"qa--mavely_links_scrollable_area\"],[16,\"data-test-id\",[52,[30,0,[\"selectedFolderId\"]],[28,[37,19],[\"selected-folder-\",[30,0,[\"selectedFolderId\"]],\"-links\"],null],\"all-links\"]],[4,[38,20],[[30,0,[\"bindScrollEvent\"]]],null],[4,[38,21],[[30,0,[\"scrollbarId\"]]],[[\"updateTrigger\"],[[28,[37,6],[[30,0,[\"links\",\"length\"]],[30,0,[\"folders\",\"length\"]]],null]]]],[12],[1,\"\\n            \"],[10,0],[14,0,\"cLB--linksModal__header cLB--linksModal__bodyHeader cLB--linkItem u--text--xs u--text--bold\"],[12],[1,\"\\n              \"],[10,0],[14,0,\"cLB--linkItem__productWrapper\"],[12],[1,\"\\n                \"],[1,[28,[35,4],[\"mavely.links_modal.body_header.product\"],null]],[1,\"\\n              \"],[13],[1,\"\\n              \"],[10,0],[14,0,\"cLB--linkItem__dateWrapper\"],[12],[1,\"\\n                \"],[1,[28,[35,4],[\"mavely.links_modal.body_header.date_added\"],null]],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n\"],[42,[28,[37,23],[[28,[37,23],[[30,0,[\"links\"]]],null]],null],null,[[[1,\"              \"],[8,[39,24],null,[[\"@link\",\"@selectLink\"],[[30,5],[30,6]]],null],[1,\"\\n              \"],[10,\"hr\"],[14,0,\"u--m__0\"],[12],[13],[1,\"\\n\"]],[5]],null],[1,\"\\n\"],[41,[30,0,[\"canLoadMoreLinks\"]],[[[1,\"              \"],[10,0],[14,0,\"u--m\"],[12],[1,\"\\n                \"],[8,[39,10],[[24,\"data-qa-id\",\"qa--mavely_links_load_more_btn\"],[24,\"data-test-id\",\"load-more-links-button\"]],[[\"@additional\",\"@class\",\"@promise\",\"@text\",\"@variant\"],[\"block\",\"cLB--linksModal__footer u--text--hl\",[30,0,[\"fetchMoreLinks\"]],[28,[37,4],[\"shared_phrases.load_more\"],null],\"outline\"]],null],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null],[1,\"          \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"searchQuery\"]],[[[1,\"          \"],[10,0],[15,0,[28,[37,18],[\"u--flex u--flex__justify--center u--flex__alignSelf--center\",[52,[30,0,[\"hasFoldersInSidebar\"]],\"u--col__9\",\"u--col__12\"]],null]],[12],[1,\"\\n            \"],[10,2],[14,0,\"u--text--hair u--text--light\"],[14,\"data-test-id\",\"no-search-results\"],[12],[1,\"\\n              \"],[1,[28,[35,4],[\"mavely.links_modal.search.no_results\"],[[\"searchQuery\"],[[30,0,[\"searchQuery\"]]]]]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"]],[]],null]],[]]]],[]]]],[]]],[1,\"      \"]],[]]]]],[1,\"\\n\"]],[]]],[1,\"  \"]],[]]]]],[1,\"\\n\"]],[2]]]]]],[\"@close\",\"modal\",\"selectedFolder\",\"@mavelyProfile\",\"link\",\"@selectLink\"],false,[\"shared/modal\",\"if\",\"or\",\"not\",\"t\",\"shared/badge\",\"and\",\"user-agent\",\"shared/mavely/links/mobile-tabs\",\"set\",\"shared/ui/button\",\"fn\",\"svg-jar\",\"let\",\"find-by\",\"shared/mavely/links/search\",\"shared/loading-spinner\",\"shared/mavely/links/folders-tab\",\"concat-classes\",\"concat\",\"did-insert\",\"perfect-scroll\",\"each\",\"-track-array\",\"shared/mavely/links/link\"]]",
    "moduleName": "shared/components/shared/mavely/links/select-modal.hbs",
    "isStrictMode": false
  });
  let MavelyLinksSelectModalComponent = _exports.default = (_class = class MavelyLinksSelectModalComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _initializerDefineProperty(this, "mavelyAffiliateLinks", _descriptor, this);
      _initializerDefineProperty(this, "perfectScroll", _descriptor2, this);
      _initializerDefineProperty(this, "userAgent", _descriptor3, this);
      _defineProperty(this, "scrollbarId", `mavely-links-scroll-${(0, _uuid.default)()}`);
      _initializerDefineProperty(this, "folders", _descriptor4, this);
      _initializerDefineProperty(this, "hasMoreFolders", _descriptor5, this);
      _initializerDefineProperty(this, "hasMoreLinks", _descriptor6, this);
      _initializerDefineProperty(this, "hasReachedModalEnd", _descriptor7, this);
      _initializerDefineProperty(this, "links", _descriptor8, this);
      _initializerDefineProperty(this, "offset", _descriptor9, this);
      _initializerDefineProperty(this, "searchQuery", _descriptor10, this);
      _initializerDefineProperty(this, "selectedFolderId", _descriptor11, this);
      _initializerDefineProperty(this, "isFoldersTabActive", _descriptor12, this);
      _defineProperty(this, "fetchFolder", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (folderId) {
          const mavelyFolderData = yield this.mavelyAffiliateLinks.fetchFolder.perform(this.mavelyProfileId, folderId);
          if (mavelyFolderData) {
            this.links = mavelyFolderData.affiliate_links ?? [];
            this.offset = mavelyFolderData.affiliate_links?.length ?? 0;
          }
        }
      }), null, "fetchFolder", null));
      _defineProperty(this, "fetchFolders", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const mavelyFolderData = yield this.mavelyAffiliateLinks.fetchFolders.perform(this.mavelyProfileId, 0, this.mavelyAffiliateLinks.standardLimitPerRequest);
          if (mavelyFolderData) {
            this.folders = mavelyFolderData.folders;
            this.hasMoreFolders = mavelyFolderData.has_next_page;
          }
        }
      }), null, "fetchFolders", null));
      _defineProperty(this, "fetchLinks", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const numberOfLinksAlreadyFetched = 0;
          const mavelyLinksData = yield this.mavelyAffiliateLinks.fetchLinks.perform(this.mavelyProfileId, numberOfLinksAlreadyFetched, this.offset);
          if (mavelyLinksData) {
            this.links = mavelyLinksData.links;
            this.hasMoreLinks = mavelyLinksData.has_next_page;
          }
        }
      }), null, "fetchLinks", null));
      _defineProperty(this, "fetchMoreFolders", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const mavelyFolderData = yield this.mavelyAffiliateLinks.fetchFolders.perform(this.mavelyProfileId, this.folders.length, this.mavelyAffiliateLinks.standardLimitPerRequest);
          if (mavelyFolderData) {
            this.folders = [...this.folders, ...mavelyFolderData.folders];
            this.hasMoreFolders = mavelyFolderData.has_next_page;
          }
        }
      }), null, "fetchMoreFolders", null));
      _defineProperty(this, "fetchMoreLinks", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const hasSearchQuery = (0, _utils.isPresent)(this.searchQuery);
          if (hasSearchQuery) {
            const mavelyLinksData = yield this.mavelyAffiliateLinks.fetchLinks.perform(this.mavelyProfileId, this.offset, this.mavelyAffiliateLinks.standardLimitPerRequest, undefined, this.searchQuery);
            this.setLinksData(mavelyLinksData, hasSearchQuery);
          } else {
            const mavelyLinksData = yield this.mavelyAffiliateLinks.fetchLinks.perform(this.mavelyProfileId, this.offset, this.mavelyAffiliateLinks.standardLimitPerRequest);
            this.setLinksData(mavelyLinksData);
          }
        }
      }), null, "fetchMoreLinks", null));
      this.hasMoreLinks = this.mavelyAffiliateLinks.profileLinks[this.mavelyProfileId]?.has_next_page;
      this.links = this.mavelyAffiliateLinks.profileLinks[this.mavelyProfileId]?.links ?? [];
      this.offset = this.mavelyAffiliateLinks.standardLimitPerRequest;
      this.fetchLinks.perform();
      this.fetchFolders.perform();
    }
    get canLoadMoreLinks() {
      return this.hasMoreLinks && this.hasReachedModalEnd;
    }
    get hasFolders() {
      return this.folders.length > 0;
    }
    get hasFoldersInSidebar() {
      if (this.userAgent.device.isMobile) {
        return false;
      }
      return this.hasFolders;
    }
    get hasLinks() {
      return this.links.length > 0;
    }
    get hasSelectedFolderOnMobile() {
      return !!this.selectedFolderId && this.isFoldersTabActive;
    }
    get isFetchingLinks() {
      return this.mavelyAffiliateLinks.fetchLinks.isRunning || this.mavelyAffiliateLinks.fetchFolder.isRunning;
    }
    get isSelectingFoldersOnMobile() {
      return this.isFoldersTabActive && !this.selectedFolderId;
    }
    get isLoading() {
      return this.fetchLinks.isRunning || this.fetchFolders.isRunning;
    }
    get linksCount() {
      return this.args.mavelyProfile.totalLinks ?? '0';
    }
    get mavelyProfileId() {
      return this.args.mavelyProfile.id;
    }
    bindScrollEvent(element) {
      element.addEventListener('ps-y-reach-end', () => this.setReachedModalEnd());
    }
    clearSearch(event) {
      // Do not clear search on enter key press
      if (event) {
        if ('pointerType' in event && event.pointerType !== 'mouse' || 'type' in event && event.type !== 'click') {
          return;
        }
      }
      this.searchQuery = '';
      this.resetLinks();
    }
    resetLinks() {
      this.links = this.mavelyAffiliateLinks.profileLinks[this.mavelyProfileId].links;
      this.hasMoreLinks = this.mavelyAffiliateLinks.profileLinks[this.mavelyProfileId].has_next_page;
      this.offset = this.mavelyAffiliateLinks.profileLinks[this.mavelyProfileId].links.length;
      this.perfectScroll.scrollToTop(this.scrollbarId);
    }
    selectFolder(id) {
      this.clearSearch();
      if (id) {
        this.selectedFolderId = id;
        this.hasMoreLinks = false;
        this.fetchFolder.perform(id);
      } else {
        this.selectedFolderId = undefined;
      }
    }
    setLinksData(mavelyLinksData) {
      let hasSearchQuery = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (mavelyLinksData) {
        if (hasSearchQuery) {
          this.links = [...this.links, ...mavelyLinksData.links];
          this.offset = this.offset + mavelyLinksData.count;
          this.hasMoreLinks = mavelyLinksData.has_next_page;
        } else {
          this.links = mavelyLinksData.links;
          this.hasMoreLinks = mavelyLinksData.has_next_page;
          this.offset = mavelyLinksData.count;
        }
        this.hasReachedModalEnd = false;
        this.selectedFolderId = undefined;
      }
    }
    setReachedModalEnd() {
      this.hasReachedModalEnd = true;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "mavelyAffiliateLinks", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "perfectScroll", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "userAgent", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "folders", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return [];
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "hasMoreFolders", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "hasMoreLinks", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "hasReachedModalEnd", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "links", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "offset", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "searchQuery", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "selectedFolderId", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "isFoldersTabActive", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "bindScrollEvent", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "bindScrollEvent"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearSearch", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "clearSearch"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetLinks", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "resetLinks"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectFolder", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "selectFolder"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setLinksData", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setLinksData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setReachedModalEnd", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setReachedModalEnd"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, MavelyLinksSelectModalComponent);
});